import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation, Thumbs, Keyboard, Pagination } from "swiper/modules";
import "swiper/css";

// import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "../../products//ProductDetails/styles.css";
import { Button, CircularProgress, Grid, IconButton, TextField } from "@mui/material";

import { Add, Search } from "@mui/icons-material";

import Card from "@mui/material/Card";
import { productApi } from "store/api";
import { useNavigate } from "react-router";

import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Grid2 from "@mui/material/Unstable_Grid2";
// import AddProductFromExcel from "../AddProductFromExcel";
import Success from "components/Success";
import { productUploadFromExcelApi } from "store/api";
import WarehouseList from "./WarehouseList";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function WarehouseTab () {
  const navigate = useNavigate();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [success, setSuccess] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [msg, setMsg] = React.useState(false);
  const [products, setProducts] = React.useState([]);
  const [noData, setNodata] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FetchProduct = async searchTerm => {
    setLoader(true);
    setNodata(false)
    const params = !searchTerm
      ? {}
      : {
          keyword: searchTerm,
        };
    try {
      const response = await productApi(params);
      if (response?.success) {
        setLoader(false);
        if (Array.isArray(response?.data)) {
          response.data = response.data.map(product => ({
            ...product,
            colors:
              product.colors?.map((color, index) => ({
                ...color,
                isColor: index === 0, // First color gets true, others false
              })) || [], // Ensure colors is always an array
          }));
        }
        setProducts(response?.data);
        if (!response?.data?.length) setNodata(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeProduct = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchProduct(value);
    }, 500);

    setDebounceTimeout(newTimeout);
  };
  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  const redirectAdd = () => {
    navigate("/add-product");
  };
  React.useEffect(() => {
    FetchProduct();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Products</Typography>
        <div style={{ display: "flex", gap: "20px" }}>
          {/* <Button
            variant='contained'
            startIcon={<Add />}
            color='success'
            onClick={() => handleOpenExcel()}
            //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
          >
            Add Bulk Product
          </Button> */}
          <Button
            variant='contained'
            startIcon={<Add />}
            color='success'
            onClick={() => redirectAdd()}
            //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
          >
            Add New
          </Button>
        </div>
      </div>

      {/* Search and Rows Per Page */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeProduct}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Products' {...a11yProps(0)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {noData && <div>No Product found</div>}
            {loader && <CircularProgress color='success' />}
            {products?.length > 0 && <WarehouseList users={products} active={0} />}
          </Grid2>
        </TabPanel>
      </Box>
      {/* <AddProductFromExcel
        open={open}
        file={file}
        handleClose={handleClose}
        handleSubmit={handleUpload}
        handleChange={handleFileChange}
      /> */}
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </div>
  );
}
